import axios from 'axios'
import type { OrganizationSettings } from '@/modules/settings/types/organizationSettings.types'
import { BASE_URL } from '@/environment/environment'

const API_URL = `${BASE_URL}/api/hospital/settings`

export const hospitalSettingsApi = {
  async get(): Promise<OrganizationSettings | null> {
    const { data } = await axios.get<OrganizationSettings | null>(`${API_URL}/`)
    return data
  },

  async save(payload: FormData | Record<string, unknown>): Promise<OrganizationSettings> {
    const isFormData = payload instanceof FormData
    const { data } = await axios.patch<OrganizationSettings>(`${API_URL}/`, payload, isFormData ? {
      headers: { 'Content-Type': 'multipart/form-data' },
    } : undefined)
    return data
  },

  async deleteLogo(): Promise<OrganizationSettings> {
    const { data } = await axios.delete<OrganizationSettings>(`${API_URL}/logo/`)
    return data
  },
}

